__turbopack_context__.v({
  "active": "DoorTypeNav-module-scss-module__4a3x4W__active",
  "container": "DoorTypeNav-module-scss-module__4a3x4W__container",
  "doorTypeNav": "DoorTypeNav-module-scss-module__4a3x4W__doorTypeNav",
  "label": "DoorTypeNav-module-scss-module__4a3x4W__label",
  "navLink": "DoorTypeNav-module-scss-module__4a3x4W__navLink",
  "navList": "DoorTypeNav-module-scss-module__4a3x4W__navList",
});
